/** Shared presentation precedence; no subscription or billing effects. */
export function subscriptionCycleLabel(cancelAtPeriodEnd: boolean, hasPendingUpdate: boolean) {
  if (cancelAtPeriodEnd) return 'Finaliza';
  return hasPendingUpdate ? 'Cambia' : 'Renueva';
}
